<div class="content-block">

    <!-- Content Header (Page header) -->
    
    <div class="content-header">
       <div class="container-fluid">
         <div class="row">
           <div class="col-sm-6">
             <h1 class="m-0 text-dark">Dipendente: {{dipendente?.nominativo}}</h1>
           </div><!-- /.col -->
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a href="/home" title="Dashboard">Dashboard</a></li>
               <li class="breadcrumb-item"><a href="/dipendenti" title="Elenco dipendenti">Dipendenti</a></li>
               <li class="breadcrumb-item">{{dipendente?.nominativo}}</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
     </div>
     <!-- /.content-header -->
</div>

<div class="content-block">
    <div class="row">   
        <div class="col-md-12">
            <div class="card">
                <div class="nav-tabs-custom">
                  <ul class="nav nav-pills">
                    <li class="nav-item"><a class="nav-link" href="#dettaglio-dip" data-bs-toggle="tab" [class]="{'active':activeTab === 'dettaglio-dip'}" (click)="changeTab('dettaglio-dip')">Dettaglio dipendente</a></li> 
                    <li class="nav-item"><a class="nav-link" href="#allegati-dipendente" data-bs-toggle="tab" [class]="{'active':activeTab === 'allegati-dipendente'}" (click)="changeTab('allegati-dipendente')">Allegati dipendente</a></li>                   
                    <li class="nav-item"><a class="nav-link" href="#consegne-dipendente" data-bs-toggle="tab" [class]="{'active':activeTab === 'consegne-dipendente'}" (click)="changeTab('consegne-dipendente')">Articoli consegnati</a></li>
                    <li class="nav-item"><a class="nav-link" href="#dettaglio-articoli" data-bs-toggle="tab" [class]="{'active':activeTab === 'dettaglio-articoli'}" (click)="changeTab('dettaglio-articoli')">Articoli previsti</a></li>
                    <li class="nav-item"><a class="nav-link" href="#dettaglio-scadenze" data-bs-toggle="tab" [class]="{'active':activeTab === 'dettaglio-scadenze'}" (click)="changeTab('dettaglio-scadenze')">Scadenze</a></li>                   
                  </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                      <div class="tab-pane" id="dettaglio-dip" [class]="{'active':activeTab === 'dettaglio-dip'}">
                        <app-form-dipendente  [idDipendente]="idDipendente" (dataDipendenteEventEmitter)="onDataDipendenteEvent($event)"></app-form-dipendente>
                      </div><!-- /.tab-pane --> 
                      <div class="tab-pane" id="allegati-dipendente" [class]="{'active':activeTab === 'allegati-dipendente'}">
                        <app-grid-allegati-dipendente [dipendente]="dipendente"></app-grid-allegati-dipendente>
                      </div><!-- /.tab-pane -->   
                      <div class="tab-pane" id="consegne-dipendente" [class]="{'active':activeTab === 'consegne-dipendente'}">
                        <app-articoli-consegnati [idDipendente]="idDipendente" [idArticolo]="0" [filterEnable]="true"></app-articoli-consegnati>
                        <app-grid-consegne [idDipendente]="idDipendente"></app-grid-consegne>
                      </div><!-- /.tab-pane -->                      
                      <div class="tab-pane" id="dettaglio-articoli" [class]="{'active':activeTab === 'dettaglio-articoli'}">
                        <app-gestione-articoli-previsti [idDipendente]="idDipendente" [idMansione]="dipendente?.idMansione"></app-gestione-articoli-previsti>
                       <!-- vecchia gestione-->
                        <!--<app-dipendente-dettaglio-articoli [idDipendente]="idDipendente" [idCatArticolo]="idCatArticolo" [bConsultazione]="false" [reloadDataBs]="reloadDataBs" [showProposte]="true"></app-dipendente-dettaglio-articoli>
                      -->
                      </div><!-- /.tab-pane -->
                      <div class="tab-pane" id="dettaglio-scadenze" [class]="{'active':activeTab === 'dettaglio-scadenze'}">              
                          <app-grid-scadenze-dipendenti [idDipendente]="idDipendente"></app-grid-scadenze-dipendenti>    
                      </div>

                     
                  </div> <!-- fine tab-content-->

                </div><!-- fine card-body-->
            </div> <!--fine card-->
        </div>
    </div>

</div>
